import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Sparkles } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("Le mot de passe doit contenir au moins 6 caractères.");
      return;
    }
    setLoading(true);
    try {
      await register(email, password, name || null);
      toast.success("Compte créé !");
      navigate("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Inscription impossible");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8" data-testid="register-logo">
          <span className="grid h-9 w-9 place-items-center rounded-lg bg-blue-600 text-white">
            <Sparkles className="h-4 w-4" />
          </span>
          <span className="font-jakarta text-xl font-bold text-slate-900">AlternAI</span>
        </Link>

        <Card className="p-8 rounded-2xl border-slate-200 shadow-sm bg-white">
          <h1 className="font-jakarta text-2xl font-bold text-slate-900">Créer un compte</h1>
          <p className="mt-1 text-sm text-slate-500">Commence en 30 secondes.</p>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="name" className="text-slate-700">Prénom <span className="text-slate-400 font-normal">(facultatif)</span></Label>
              <Input id="name" data-testid="register-name" value={name} onChange={(e) => setName(e.target.value)} className="mt-1.5 h-11" placeholder="Ton prénom" />
            </div>
            <div>
              <Label htmlFor="email" className="text-slate-700">Email</Label>
              <Input id="email" data-testid="register-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-11" placeholder="ton@email.com" />
            </div>
            <div>
              <Label htmlFor="password" className="text-slate-700">Mot de passe</Label>
              <Input id="password" data-testid="register-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-11" placeholder="Min. 6 caractères" />
            </div>
            <Button type="submit" disabled={loading} className="w-full h-11 bg-blue-600 hover:bg-blue-700 rounded-full" data-testid="register-submit">
              {loading ? "Création…" : "Créer mon compte"}
            </Button>
          </form>

          <div className="mt-6 text-center text-sm text-slate-500">
            Déjà un compte ?{" "}
            <Link to="/login" className="text-blue-600 hover:text-blue-700 font-medium" data-testid="register-to-login">
              Se connecter
            </Link>
          </div>
        </Card>
      </div>
    </div>
  );
}
